document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".seo-toggle").forEach((box) => {
    const btn = box.querySelector(".seo-toggle__btn");
    const icon = box.querySelector(".seo-toggle__icon");
    if (!btn) return;

    // Kapalı başla (hidden yok, sadece class ile kontrol)
    box.classList.remove("is-open");
    btn.setAttribute("aria-expanded", "false");
    if (icon) icon.textContent = "+";

    btn.addEventListener("click", () => {
      const isOpen = box.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", String(isOpen));
      if (icon) icon.textContent = isOpen ? "×" : "+";
    });
  });
});
